import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import About from './pages/About';
import ProfilePage from './pages/ProfilePage';
import DownloadPage from './pages/download';
import { AuthProvider } from './context/AuthContext';
import { AnimatePresence } from 'framer-motion';
import TimerGate from './elements/TimerGate';
import SecretPage from './pages/secret';
import DummyReview from './pages/dummy_reviews';

function App() {
  return (
    <Router>
      <AuthProvider>
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/about" element={<About />} />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="/bm-install" element={<DownloadPage />} />
              <Route path="/dummy-review" element={<DummyReview />} />
            </Routes>
          </AnimatePresence>
      </AuthProvider>
    </Router>
  );
}

export default App;